/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './work-flow-step.reducer';

export const WorkFlowStepDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workFlowStepEntity = useAppSelector(state => state.workFlowStep.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workFlowStepDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.workFlowStep.detail.title">WorkFlowStep</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.id">Id</Translate>
            </span>
          </dt>
          <dd>{workFlowStepEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.description}</dd>
          <dt>
            <span id="sequence">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.sequence">Sequence</Translate>
            </span>
            <UncontrolledTooltip target="sequence">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.sequence" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.sequence}</dd>
          <dt>
            <span id="approvalRequired">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.approvalRequired">Approval Required</Translate>
            </span>
            <UncontrolledTooltip target="approvalRequired">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.approvalRequired" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.approvalRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="unitsOfMeasure">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.unitsOfMeasure">Units Of Measure</Translate>
            </span>
            <UncontrolledTooltip target="unitsOfMeasure">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.unitsOfMeasure" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.unitsOfMeasure}</dd>
          <dt>
            <span id="valueType">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.valueType">Value Type</Translate>
            </span>
            <UncontrolledTooltip target="valueType">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.valueType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.valueType}</dd>
          <dt>
            <span id="valueRange">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.valueRange">Value Range</Translate>
            </span>
            <UncontrolledTooltip target="valueRange">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.valueRange" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.valueRange}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowStep.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowStep.role">Role</Translate>
          </dt>
          <dd>{workFlowStepEntity.role ? workFlowStepEntity.role.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowStep.stepType">Step Type</Translate>
          </dt>
          <dd>{workFlowStepEntity.stepType ? workFlowStepEntity.stepType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowStep.protocol">Protocol</Translate>
          </dt>
          <dd>{workFlowStepEntity.protocol ? workFlowStepEntity.protocol.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/work-flow-step" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/work-flow-step/${workFlowStepEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkFlowStepDetail;
